import React, { createContext, useContext } from 'react';
import { useSpinradState, SpinradState } from '../hooks/useSpinradState';

const SpinradContext = createContext<SpinradState | null>(null);

export const SpinradProvider: React.FC<{
  children: React.ReactNode;
  coreValues: string[];
  usergroupId: number | undefined;
}> = ({ children, coreValues, usergroupId }) => {
  const state = useSpinradState(coreValues, usergroupId);
  return (
    <SpinradContext.Provider value={state}>{children}</SpinradContext.Provider>
  );
};

export const useSpinradContext = (): SpinradState => {
  const ctx = useContext(SpinradContext);
  if (!ctx) {
    throw new Error('useSpinradContext must be used within a SpinradProvider');
  }
  return ctx;
};
